import Env from './env'
import {compareVersion, parseVersion} from './utils'
import {API} from './api'
import {support, handle, fn} from './core'

const {isAndroidApp, isIOSApp, isApp, appVersion} = Env

function version (...args) {
    // 无参数调用返回版本号
    if (args.length === 0) {
        return Env.appVersion
    } else {
        return compareVersion.apply(null, args)
    }
}

// callHandler透传外部调用的参数，对于不存在于API列表中的方法，可以使用其进行调用，但是不支持support方法检测
function callHandler (...args) {
    handle.apply(null, args)
}

// 分享的简写方法，为了向前兼容，非标准，不推荐使用
function share (...args) {
    let fnName = args[0]
    let fnArgs = [fnName, API[fnName], args.slice(1)]
    fn.apply(null, fnArgs)
}

const DBridge = {
    isIOSApp,
    isAndroidApp,
    isApp,
    appVersion,
    compareVersion,
    parseVersion,
    support,
    handle,
    fn,
    version,
    callHandler,
    share
}

Object.keys(API).forEach((key) => {
    DBridge[key] = (...args) => {
        let fnArgs = [key, API[key], args]
        fn.apply(null, fnArgs)
    }
})

export {
    DBridge as dbridge
}
